import { CaretRightOutlined } from "@ant-design/icons";
import { Collapse, Input, Switch, Select, message } from "antd";
import { useFormik } from "formik";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cardEnalbeLimit,
  set_card_policy,
  CardLimitEnable,
} from "../../actions/cards/cards";
import EditIcon from "../../assets/icons/edit.png";
import save from "../../assets/icons/save.png";
import close from "../../assets/icons/close.png";
import no_limits from "../../assets/images/no_limits.png";
import * as yup from "yup";
import "./card.css";
import BaseCurrency from "../Common/BaseCurrency";
import { hasAccess } from "../../utils";
import PosLimitComponent from "./PosLimitsTxn";

const schema = yup.object().shape({
  transaction_type: yup.string().required(),
  amount: yup.string().required(),
  frequency: yup.string().required(),
});
const { Panel } = Collapse;
const { Option } = Select;

const CardSettingsAccordion = ({
  card_id,
  channels,
  card_limits,
  card_ref_number,
}) => {
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );
  const setCardLimit = useSelector((state) => state.cards.set_card_policy);
  const card_enalbe = useSelector((state) => state.cards.card_enable);

  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      card_id,
      card_ref_number,
      transaction_type: "",
      amount: "",
      frequency: "",
    },
    validationSchema: schema,
    onSubmit: (vals, { setSubmitting }) => {
      dispatch(set_card_policy({ card: vals }));
      setSubmitting(false);
    },
  });

  const prevTxnEnableRef = useRef(null);
  const pendingToggleRef = useRef(null);

  const channelsToState = (ch) => ({
    ECOM: ch?.includes("ECOM"),
    ATM: ch?.includes("ATM"),
    POS: ch?.includes("POS"),
    CTLS: ch?.includes("CTLS"),
  });

  const [txnEnable, setTxnEnable] = useState({
    ECOM: false,
    ATM: false,
    POS: false,
    CTLS: false,
  });

  const [isAdd, setIsAdd] = useState(false);
  useEffect(() => {
    if (!channels) return;
    const next = channelsToState(channels);
    setTxnEnable(next);
    prevTxnEnableRef.current = next;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card_id]);

  const toggleTxn = (type, val) => {
    prevTxnEnableRef.current = txnEnable;
    pendingToggleRef.current = { type, val };
    dispatch(
      cardEnalbeLimit({
        card: {
          card_id,
          transaction_type: type,
          is_enabled: val,
        },
      }),
    );
  };

  useEffect(() => {
    if (setCardLimit?.success) {
      setIsAdd(false);
      formik.resetForm();
      formik.setValues({
        card_id,
        card_ref_number,
        transaction_type: "",
        amount: "",
        frequency: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCardLimit]);

  useEffect(() => {
    if (
      !card_enalbe?.loading &&
      (card_enalbe?.success === false ||
        (card_enalbe?.success === true && !card_enalbe?.data?.status))
    ) {
      pendingToggleRef.current = null;
      dispatch({
        type: CardLimitEnable.RESET,
      });
    }
    if (
      !card_enalbe?.loading &&
      card_enalbe?.success === true &&
      card_enalbe?.data?.status
    ) {
      const pending = pendingToggleRef.current;
      if (pending?.type) {
        setTxnEnable((prev) => ({
          ...prev,
          [pending.type]: pending.val,
        }));
        prevTxnEnableRef.current = {
          ...(prevTxnEnableRef.current || txnEnable),
          [pending.type]: pending.val,
        };
      }
      pendingToggleRef.current = null;
      dispatch({
        type: CardLimitEnable.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card_enalbe]);

  return (
    <div className="pt1 pb1 pl1">
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        defaultActiveKey={"card-usage"}
        expandIconPosition={"right"}
        className="site-collapse-custom-collapse"
      >
        <Panel
          header={`Card Usage Controls`}
          className="accordion-heading"
          key={"card-usage"}
        >
          <div className="card-usage">
            <div className="item">
              <div>
                <span>POS</span>
                <span></span>
              </div>
              <Switch
                className="switch"
                checked={txnEnable["POS"]}
                disabled={
                  (is_admin && !hasAccess("cards", "write")) ||
                  card_enalbe?.loading
                }
                onChange={(val) => toggleTxn("POS", val)}
              />
            </div>
            <div className="item">
              <div>
                <span>ATM Withdrawal</span>
                <span></span>
              </div>
              <Switch
                className="switch"
                checked={txnEnable["ATM"]}
                disabled={
                  (is_admin && !hasAccess("cards", "write")) ||
                  card_enalbe?.loading
                }
                onChange={(val) => toggleTxn("ATM", val)}
              />
            </div>
            <div className="item">
              <div>
                <span>Online Transactions</span>
                <span></span>
              </div>
              <Switch
                className="switch"
                checked={txnEnable["ECOM"]}
                disabled={
                  (is_admin && !hasAccess("cards", "write")) ||
                  card_enalbe?.loading
                }
                onChange={(val) => toggleTxn("ECOM", val)}
              />
            </div>
            <div className="item">
              <div>
                <span>ContactLess</span>
                <span></span>
              </div>
              <Switch
                className="switch"
                checked={txnEnable["CTLS"]}
                disabled={
                  (is_admin && !hasAccess("cards", "write")) ||
                  card_enalbe?.loading
                }
                onChange={(val) => toggleTxn("CTLS", val)}
              />
            </div>
          </div>
        </Panel>
      </Collapse>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        expandIconPosition={"right"}
        className="site-collapse-custom-collapse"
      >
        <Panel header={"Card Limits"} key="1" className="accordion-heading">
          <div className="flex-col">
            {card_limits?.length >= 1 ? (
              <PosLimitComponent
                cardLimit={card_limits}
                card_id={card_id}
                card_ref_number={card_ref_number}
                txnEnable={txnEnable} // Pass the switch state
              />
            ) : (
              <div className="no-data limits">
                <img alt="" src={no_limits} width={100} />
                <span>No Limits are configured by the administrator</span>
              </div>
            )}

            {/* {is_admin && !hasAccess("cards", "write") && ( */}
            {/* <button
                className="primary-text fs-1"
                disabled={isAdd}
                onClick={() => {
                  setIsAdd(true);
                }}
              >
                + Add new limit
              </button> */}
            {/* )} */}
          </div>
          <br />
        </Panel>
      </Collapse>
    </div>
  );
};

const SpendLimits = ({
  current,
  max,
  type,
  transaction_type,
  onEdit,
  isEdit,
  formik,
  onSubmit,
  is_admin,
  isAdd,
  availableChannels,
  closeAdd,
}) => {
  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="alignItemsToFlexStart">
        <div>
          <div className="inputDivTag">
            <label className="poppinsNormalFont twelveFontSize spend-limits">
              Spend Limits
            </label>
            <Input
              prefix={<BaseCurrency />}
              className="inputTag"
              name="amount"
              onChange={formik.handleChange}
              disabled={isAdd ? false : !isEdit}
              value={isEdit || isAdd ? formik.values.amount : current}
            />
            {isAdd && formik.touched.amount && formik.errors.amount && (
              <div className="errorMsg">{formik.errors.amount}</div>
            )}
          </div>
        </div>
        <div>
          <div className="inputDivTag">
            <label className="poppinsNormalFont twelveFontSize">Per</label>
            {isAdd ? (
              <Select
                placeholder="Select "
                onChange={(val) => formik.setFieldValue(`frequency`, val)}
                value={formik.values.frequency}
              >
                {!availableChannels?.find(
                  (ele) =>
                    ele.type.includes("DAILY") &&
                    ele.channel === formik.values.transaction_type,
                ) && <Option value="DAILY">Daily Limit</Option>}
                {!availableChannels?.find(
                  (ele) =>
                    ele.type.includes("MONTHLY") &&
                    ele.channel === formik.values.transaction_type,
                ) && <Option value="MONTHLY">Monthly Limit</Option>}
                {!availableChannels?.find(
                  (ele) =>
                    ele.type.includes("ANNUALLY") &&
                    ele.channel === formik.values.transaction_type,
                ) && <Option value="ANNUALLY">Yearly Limit</Option>}
              </Select>
            ) : (
              <Input
                value={type}
                className="inputTag"
                disabled
                style={{
                  width: "3rem",
                }}
              />
            )}
          </div>
          {isAdd && formik.touched.frequency && formik.errors.frequency && (
            <div className="errorMsg">{formik.errors.frequency}</div>
          )}
        </div>
        <div>
          <div className="inputDivTag">
            <label className="poppinsNormalFont twelveFontSize">On</label>
            {isAdd ? (
              <Select
                placeholder="Select "
                onChange={(val) =>
                  formik.setFieldValue(`transaction_type`, val)
                }
                value={formik.values.transaction_type}
              >
                {!availableChannels?.find(
                  (ele) =>
                    ele.type.includes(formik.values.frequency) &&
                    ele.channel === "ATM",
                ) && <Option value="ATM">ATM</Option>}
                {!availableChannels?.find(
                  (ele) =>
                    ele.type.includes(formik.values.frequency) &&
                    ele.channel === "POS",
                ) && <Option value="POS">POS</Option>}
                {!availableChannels?.find(
                  (ele) =>
                    ele.type.includes(formik.values.frequency) &&
                    ele.channel === "ECOM",
                ) && <Option value="ECOM">Online</Option>}
                {!availableChannels?.find(
                  (ele) =>
                    ele.type.includes(formik.values.frequency) &&
                    ele.channel === "CTLS",
                ) && <Option value="CTLS">ContactLess</Option>}
              </Select>
            ) : (
              <Input value={transaction_type} className="inputTag" disabled />
            )}
          </div>
          {isAdd &&
            formik.touched.transaction_type &&
            formik.errors.transaction_type && (
              <div className="errorMsg">{formik.errors.transaction_type}</div>
            )}
        </div>
        {!isAdd && (
          <div className="inputDivTag">
            <label className="poppinsNormalFont twelveFontSize max-limits">
              Max Limit
            </label>
            <Input
              prefix={<BaseCurrency />}
              value={max}
              className="inputTag"
              disabled
            />
          </div>
        )}
        {/* {is_admin && hasAccess("cards", "write") && */}
        <div className="actions">
          {isEdit || isAdd ? (
            <>
              <button
                type={isEdit ? "button" : "submit"}
                className="ml1"
                onClick={() => {
                  if (isEdit) onSubmit();
                }}
              >
                <img src={save} alt="" width={16} />
              </button>
              <button
                type="button"
                className="ml1"
                onClick={() => {
                  if (isAdd) closeAdd();
                  else {
                    onEdit(true);
                  }
                }}
              >
                <img src={close} alt="" width={16} />
              </button>
            </>
          ) : (
            <button
              className="ml1"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
            >
              <img src={EditIcon} alt={"logo"} width={25} />
            </button>
          )}
        </div>
        {/*  } */}
      </div>
    </form>
  );
};

export default CardSettingsAccordion;
